import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createVNode as _createVNode, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6a89c8d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ArticleList" }
const _hoisted_2 = { class: "ArticleList-main" }
const _hoisted_3 = { class: "ArticleList-pagination" }

import { reactive, onMounted, watch } from 'vue'
import ArticleItem from './ArticleItem.vue'
import {
  getFrogArticleList,
  getArchiveArticleList
} from '@/apis/frog'
import { t } from '@/plugins/i18n'
import { useSite2Station } from '@/store'
import { useRoute, useRouter } from 'vue-router'
import { useRequest } from '@/util/useLoading'
import MemberEventBox from '@/components/common/MemberEventBox.vue'
import { getJapanTime as setStationTime } from '@/util/common'


export default /*#__PURE__*/_defineComponent({
  props: {
  type: {
    type: Number,
    default: -1
  }
  // dateObj: {
  //   type: Object,
  //   default: () => {
  //     return { frogArticleYear: '2022', frogArticleMonth: '1' }
  //   }
  // }
},
  setup(__props) {

const props = __props
const route = useRoute()
const router = useRouter()
const stationCode = useSite2Station()



onMounted(() => {
  if (route.query.tab === '-2') {
    getArchiveList()
  } else {
    getList()
  }
})

// 监听type切换
watch(
  () => props.type,
  () => {
    data.page = {
      currentPage: 1,
      pageSize: 16,
      total: 0
    }
    if (props.type !== -2) {
      getList()
    }
  }
)

// 监听归档年份切换
watch(
  () => route.query.year,
  (val) => {
    data.dateObj.frogArticleYear = val
    if (route.query.tab === '-2') {
      getArchiveList()
    }
  }
)

// 监听归档月份切换
watch(
  () => route.query.month,
  (val) => {
    data.dateObj.frogArticleMonth = val
    if (route.query.tab === '-2') {
      getArchiveList()
    }
  }
)

const data: any = reactive({
  // 列表
  list: [],
  // 分页对象
  page: {
    currentPage: 1,
    pageSize: 16,
    total: 0
  },
  dateObj: {
    frogArticleYear: route.query.year,
    frogArticleMonth: route.query.month
  }
})

// 获取文章列表
const [loading, getList] = useRequest(() => {
  const formData = {
    frogArticleType: judgeType(props.type),
    pageNum: data.page.currentPage,
    pageSize: data.page.pageSize,
    stationCode
  }
  return getFrogArticleList(formData).then((res: any) => {
    if (res.code === '0') {
      data.list = res.data.records.map((item:any) => {
        return {
          ...item,
          createTime: item.frogArticleId === '151' ? '' : setStationTime(item.createTime)
        }
      })
      data.page.total = res.data.total
    }
  })
})

// 获取归档文章列表
const [loadingDate, getArchiveList] = useRequest(() => {
  const { frogArticleYear, frogArticleMonth } = data.dateObj
  const formData = {
    frogArticleYear,
    frogArticleMonth,
    pageNum: data.page.currentPage,
    pageSize: data.page.pageSize,
    stationCode
  }
  if (formData.frogArticleYear && formData.frogArticleMonth) {
    return getArchiveArticleList(formData).then((res: any) => {
      if (res.code === '0') {
        data.list = res.data.records
        data.page.total = res.data.total
      }
    })
  } else {
    return Promise.resolve()
  }
})

// 判断type
const judgeType = (type: number) => {
  if (type === -1) {
    // 获取全部，传null
    return null
  } else {
    return type
  }
}

// 判断typeList
const judgeTypeList = (type: number) => {
  if (type === -1) {
    // 获取全部，传null
    return ['0', '1', '2', '3', '4', '5']
  } else {
    return [type]
  }
}

// 分页切换
const pageChange = (page: number) => {
  data.page.currentPage = page
  getList()
}

// size切换
const sizeChange = (size: number) => {
  data.page.currentPage = 1
  data.page.pageSize = size
  getList()
}

// 判断进入文章详情时，携带的type
// 0.根据文章类型；1.根据文章归档年月；2.根据文章热度；3.全部文章
const judgeItemType = () => {
  if (props.type === -1) {
    return 3
  } else if (props.type === -2) {
    return 1
  } else {
    return 0
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).list, (item) => {
        return (_openBlock(), _createBlock(ArticleItem, {
          key: item.frogArticleId,
          item: item,
          type: judgeItemType()
        }, null, 8, ["item", "type"]))
      }), 128)),
      (_unref(data).list.length === 0)
        ? (_openBlock(), _createBlock(_component_el_empty, {
            key: 0,
            description: _unref(t)('没有更多了')
          }, null, 8, ["description"]))
        : _createCommentVNode("", true)
    ], 512), [
      [_directive_loading, _unref(loading) || _unref(loadingDate)]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_3, [
      _createVNode(_component_el_pagination, {
        small: "",
        background: "",
        "current-page": _unref(data).page.currentPage,
        "page-size": _unref(data).page.pageSize,
        total: _unref(data).page.total,
        "page-sizes": [16],
        layout: "prev, pager, next, sizes, jumper",
        "onUpdate:currentPage": pageChange,
        "onUpdate:pageSize": sizeChange
      }, null, 8, ["current-page", "page-size", "total"])
    ], 512), [
      [_vShow, _unref(data).list?.length !== 0]
    ])
  ]))
}
}

})